import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
  info: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = { error: null, info: null };

  public static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    this.setState({ error, info });
    // Surface to the browser console so Teams DevTools catches it.
    console.error("[tab] Render error:", error, info.componentStack);
  }

  public override render(): ReactNode {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "sans-serif" }}>
          <MessageBar intent="error">
            <MessageBarBody>
              <MessageBarTitle>Something went wrong</MessageBarTitle>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  marginTop: 8,
                  fontSize: 12,
                }}
              >
                {this.state.error.message}
                {this.state.info?.componentStack}
              </pre>
            </MessageBarBody>
          </MessageBar>
        </div>
      );
    }
    return this.props.children;
  }
}
